import { useState } from "react";
import CookiePopup from "../../components/CookiePopup";
import EulaLink from "../../components/EulaLink";
import { useSystemVersion } from "../../hooks";
import tcbase from "../../shim/tcbase";

type Props = {
  productName: string;
};

const RlFooter = ({ productName }: Props) => {
  const [isBuildVersionHide, setIsBuildVersionHide] = useState(true);
  const { buildVersion, shortVersion, ticoreVersion } = useSystemVersion();
  const showBuildVersion = () => {
    setIsBuildVersionHide(false);
  };
  const { _rlapp_user: { username } = { username: "" } } = window || {};
  const isLoggedIn = !!username;

  const showReleaseNotes = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    tcbase.showReleaseNotes();
  };

  return (
    <footer className="rlbs footer layout">
      <ul className="footer__main">
        <li className="footer__item">
          <a href="http://www.reversinglabs.com" title="ReversingLabs Website">
            ReversingLabs
          </a>
        </li>
        <li className="footer__item">
          <a
            href="https://docs.reversinglabs.com/Integrations/Browser%20Extension/overview/#installation-and-setup"
            target="_blank"
            rel="noopener noreferrer"
            data-qa-id="browser-extension"
          >
            Browser Extension
          </a>
        </li>
        {isLoggedIn && (
          <li className="footer__item">
            <a href="#" onClick={showReleaseNotes} data-qa-id="release-notes">
              What&apos;s New
            </a>
          </li>
        )}
        <li className="footer__item">
          <a href="/cookie_policy" title="Cookie Policy">
            Cookie Policy
          </a>
        </li>
        <li className="footer__item">
          <a href="/privacy_policy" title="Privacy Policy">
            Privacy Policy
          </a>
        </li>
        <li>
          <EulaLink />
        </li>
      </ul>
      <div className="footer__version">
        {isLoggedIn ? (
          <span>
            <span
              onClick={showBuildVersion}
              className={`expanding-version-display ${
                buildVersion && isBuildVersionHide ? "cursor-pointer" : ""
              }`}
            >
              {productName}, {shortVersion}
              {buildVersion && (
                <span
                  className={`build-version ${
                    isBuildVersionHide ? "hide" : ""
                  }`}
                >
                  -{buildVersion}
                </span>
              )}
            </span>
            <span className="px-10">|</span>
            Spectra Core Version: {ticoreVersion}
          </span>
        ) : (
          <span>{productName}</span>
        )}
      </div>
      <CookiePopup />
    </footer>
  );
};

export default RlFooter;
